import React from 'react';
import PropTypes from 'prop-types';

export default class extends React.Component {
  static contextTypes = {
    t: PropTypes.func
  };

  render() {
    const { msg, children, count, ...interpolate } = this.props;
    const { t } = this.context;

    if (!t) return msg;

    return t(msg, interpolate, count);
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/T.js